/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SetUserGdprConsentRequest
 */
export interface SetUserGdprConsentRequest {
  /**
   *
   * @type {string}
   * @memberof SetUserGdprConsentRequest
   */
  sessionId: string
}

/**
 * Check if a given object implements the SetUserGdprConsentRequest interface.
 */
export function instanceOfSetUserGdprConsentRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value

  return isInstance
}

export function SetUserGdprConsentRequestFromJSON(
  json: any,
): SetUserGdprConsentRequest {
  return SetUserGdprConsentRequestFromJSONTyped(json, false)
}

export function SetUserGdprConsentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetUserGdprConsentRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['session_id'],
  }
}

export function SetUserGdprConsentRequestToJSON(
  value?: SetUserGdprConsentRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    session_id: value.sessionId,
  }
}
